import { type MediaCardProps } from './MediaCard.props'

export const mediaCardDefaults = {
  children: [
    {
      '@type': '@builder.io/sdk:Element',
      '@version': 2,
      children: [
        {
          '@type': '@builder.io/sdk:Element',
          '@version': 2,
          component: {
            name: 'Text',
            options: {
              text: 'Enter some text...',
              style: 'Body XL - Medium weight',
            },
          },
          responsiveStyles: {
            large: {
              display: 'flex',
              flexDirection: 'column',
              position: 'relative',
              flexShrink: '0',
              boxSizing: 'border-box',
              height: 'auto',
              textAlign: 'left',
              marginRight: 'auto',
            },
          },
        },
        {
          '@type': '@builder.io/sdk:Element',
          '@version': 2,
          component: {
            name: 'Text',
            options: {
              text: 'Enter some text...',
              style: 'Body Base',
            },
          },
          responsiveStyles: {
            large: {
              display: 'flex',
              flexDirection: 'column',
              position: 'relative',
              flexShrink: '0',
              boxSizing: 'border-box',
              height: 'auto',
              textAlign: 'left',
              marginRight: 'auto',
              marginTop: '12px',
            },
          },
        },
      ],
      responsiveStyles: {
        large: {
          position: 'relative',
          flexShrink: '0',
          boxSizing: 'border-box',
          flexDirection: 'column',
          display: 'flex',
          height: '100%',
          justifyContent: 'flex-end',
          color: 'rgba(255, 255, 255, 1)',
        },
      },
    },
  ],
  mediaType: 'image',
  brightcoveVideoId: '6359706013112',
  videoPlayerAspectRatio: '16 / 9',
  playAsPopup: false,
  desktopImgSrc:
    'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2F6495c62d937740e9a1291ff42f6bd0b8?format=webp',
  mobileImgSrc:
    'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2F6495c62d937740e9a1291ff42f6bd0b8?format=webp',
  desktopHeight: 600,
  mobileHeight: 490,
  redirectUrl: '',
  showGradient: true,
  innerPadding: 'small',
} satisfies MediaCardProps
